import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { PRIVACY } from '../data/legal';
import { ShieldCheck, ChevronLeft } from 'lucide-react';

export default function Privacy() {
  const { lang } = useLanguage();
  return (
    <div className="container-app py-8 sm:py-12 max-w-3xl animate-fade-in-up" data-testid="privacy-page">
      <Link to="/" className="inline-flex items-center text-sm text-ink-secondary hover:text-terracotta mb-6">
        <ChevronLeft size={16} /> {lang === 'zh' ? '返回首页' : 'Home'}
      </Link>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-2xl bg-sage-light flex items-center justify-center">
          <ShieldCheck size={18} className="text-sage" />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-ink">
          {lang === 'zh' ? PRIVACY.title_zh : PRIVACY.title_en}
        </h1>
      </div>
      <p className="text-xs text-ink-tertiary mb-6">
        {lang === 'zh' ? PRIVACY.effective_zh : PRIVACY.effective_en}
      </p>
      <p className="text-ink-secondary leading-relaxed mb-8">
        {lang === 'zh' ? PRIVACY.intro_zh : PRIVACY.intro_en}
      </p>

      {PRIVACY.sections.map((s, i) => (
        <section key={i} className="card-base p-6 sm:p-8 mb-5" data-testid={`privacy-section-${i}`}>
          <h2 className="font-heading text-lg font-semibold text-ink mb-4">
            {lang === 'zh' ? s.heading_zh : s.heading_en}
          </h2>
          <ul className="space-y-2">
            {(lang === 'zh' ? s.points_zh : s.points_en).map((p, j) => (
              <li key={j} className="flex gap-3 text-ink-secondary leading-relaxed text-sm">
                <span className="text-terracotta flex-shrink-0">•</span>
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}

      <p className="text-xs text-ink-tertiary mt-6">
        {lang === 'zh'
          ? '本政策为初版，将由本地律师审阅后定稿。'
          : 'This is an initial draft; final wording will be reviewed by local counsel.'}
      </p>
    </div>
  );
}
